// extracted by mini-css-extract-plugin
export default {"list":"src-content-types-breeds-BreedsLinks__list","chevron":"src-content-types-breeds-BreedsLinks__chevron"};